/* Holidays Maker – small UI fixes */
(function () {
  // Footer link columns start closed on mobile (open on desktop)
  if (window.matchMedia('(max-width: 749px)').matches) {
    document.querySelectorAll('.hm-premium-footer details[open]').forEach(function (d) { d.removeAttribute('open'); });
  }
})();
